import { menuItemStyles as fastMenuItemStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationMenuItemStyles = (context, definition) => css `
  ${fastMenuItemStyles(context, definition)}

  :host, :host(.indent-0[aria-haspopup='menu']) {
    align-content: center;
    min-height: calc(var(--design-unit) * 8px);
  }

  .expand-collapse-glyph {
    max-height: calc(var(--design-unit) * 4px);
    max-width: calc(var(--design-unit) * 4px);
    height: auto;
    width: auto;
  }
`;
